import { Drawer, Box, Text } from '@mantine/core';
import { ProjectHistoryDto } from '../../build/generated-sources/openapi';
import React from 'react';
import { HistoryCard } from './HistoryCard';

interface HistoryDrawerProps {
  opened: boolean;
  close: () => void;
  history: ProjectHistoryDto[];
}

export const HistoryDrawer = ({ opened, close, history }: HistoryDrawerProps) => {
  const hasHistory = history.length > 0;

  return (
    <Drawer opened={opened} onClose={close} title="Historie změn" position="right" size="lg">
      {!hasHistory ? (
        <Box p="md">
          <Text>Zatím nedošlo k žádným změnám v projektu.</Text>
        </Box>
      ) : (
        <Box p="md">
          {history.map((item) => (
            <HistoryCard h={item} key={item.id} />
          ))}
        </Box>
      )}
    </Drawer>
  );
};
